// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../szc.cycz.cc/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".company-info_form[data-v-4365a546] {\n  padding: 30px 60px 60px 20px;\n}\n.dialog-footer[data-v-4365a546] {\n  position: absolute;\n  right: 20px;\n  bottom: 20px;\n}\n.editor[data-v-4365a546] {\n  margin-bottom: 20px;\n}\n.editor .summaryEditor[data-v-4365a546], .editor .termEditor[data-v-4365a546], .editor .contractEditor[data-v-4365a546] {\n  z-index: 1 !important;\n  position: relative;\n}", ""]);
// Exports
module.exports = exports;
